export const body = {
    padding: "30px",
    display: "flex",
    flex: 1,
    flexDirection: "column",
    alignItems: "center"
};

export const textBox = {
    width: "200px",
    textAlign: "center",
    border: "2px solid black"
};
